import axios, { AxiosRequestConfig } from 'axios'
import { EnvConfig } from '../src/environments/environment.interface'
import { OfpIdentityMappingResponse } from '../src/app/shared/types/ofp.types'

/**
 * Get OFP Person ID by Identity Person ID
 *
 * @param identityPersonId The identity person UUID to look up
 * @param axiosConfig Axios configuration with timeout and headers
 * @param environment Environment configuration containing ofpApiUrl
 * @returns Promise resolving to OFP ID string or null if not found/error
 */
export async function getOfpPersonIdByIdentity(
  identityPersonId: string,
  axiosConfig: AxiosRequestConfig,
  environment: EnvConfig
): Promise<string | null> {
  try {
    const url = `${environment.ofpApiUrl}/entities/ofp-ids/identity-person/person?providerIds=${identityPersonId}`

    console.log(`[ofp-api-utils] Calling OFP API - Identity ID: ${identityPersonId}, URL: ${url}`)

    const response = await axios.get<OfpIdentityMappingResponse>(url, axiosConfig)

    if (response.data?.data && response.data.data[identityPersonId] && response.data.data[identityPersonId].length > 0) {
      const ofpId = response.data.data[identityPersonId][0].ofpId
      console.log(`[ofp-api-utils] Found OFP ID: ${ofpId} for Identity ID: ${identityPersonId}`)
      return ofpId
    }

    console.log(`[ofp-api-utils] No OFP ID found for Identity ID: ${identityPersonId}`)
    return null
  } catch (error) {
    console.log(`[ofp-api-utils] Error fetching OFP ID for Identity ID: ${identityPersonId}`, error)
    return null
  }
}